import * as actionTypes from './actionTypes'

export const showSnackbar = (message, autoHideDuration = 4000) => {
  return {
    type: actionTypes.SHOW_SNACKBAR,
    payload: {
      message, autoHideDuration
    }
  }
}

export const hideSnackbar = () => {
  return {
    type: actionTypes.HIDE_SNACKBAR,
    payload: {}
  }
}



/** WEBPACK FOOTER **
 ** ./src/actions/uiActions.js
 **/